@let isSingle = institutionRequestKeys.length === 1;
@let isMulti = institutionRequestKeys.length > 1;
@let firstLink = links[0];

<ng-template #menuLabel let-annualUpdateLabel="AnnualUpdateLabel">
    @if (!annualUpdate) {
        <ng-container>
            <mat-icon fontSet="material-icons-outlined">content_paste_search</mat-icon>
            Directory
        </ng-container>
    }
    @if (annualUpdate) {
        <ng-container>
            <mat-icon fontSet="material-icons-outlined">pending_actions</mat-icon>
            {{annualUpdateLabel}}
        </ng-container>
    }
</ng-template>

@if (isSingle) {
    <a
            mat-menu-item
            routerLinkActive="active"
            [routerLink]="firstLink.programRequestKey ? ['/directory/program', institutionRequestKeys[0], firstLink.programRequestKey] : ['/directory/programs', institutionRequestKeys[0]]"
            [state]="{ activeTab: firstLink.activeTab }"
    >
        <ng-container
          [ngTemplateOutlet]="menuLabel"
          [ngTemplateOutletContext]="{ AnnualUpdateLabel: annualUpdateLabels[0] }"
        ></ng-container>
    </a>
}

@if (isMulti) {
    @for (link of links; track $index) {
        <a
                mat-menu-item
                routerLinkActive="active"
                [routerLink]="['/directory/programs', link.institutionRequestKey]"
                [queryParams]="{ programRequestKey: link.programRequestKey }"
                [state]="{ activeTab: link.activeTab }"
        >
          <ng-container
            [ngTemplateOutlet]="menuLabel"
            [ngTemplateOutletContext]="{ AnnualUpdateLabel: annualUpdateLabels[$index] }"
          ></ng-container>
        </a>
    }
}
